/**
 * Terms of service text for the informational modal (just viewing terms)
 * This is the text that should be displayed to inform users about payment method storage
 */
export const PAYMENT_METHOD_ON_FILE_INFO_TERMS_TEXT =
  'By saving payment details for future purchases, merchant hereby confirms that it has requested and received explicit cardholder consent to store card and cardholder information in this system.'
